<template>
  <div>
    <label :class="{ 'sr-only': hide_label }" :for="'input-' + id">{{ text }}</label>
    <b-form-textarea
      @keyup="emitToParent"
      v-model="value"
      :id="'input-' + id"
      :placeholder="text"
      rows="3"
      max-rows="6"
    ></b-form-textarea>
  </div>
</template>

<script>
export default {
  name: 'InputTextarea',
  props: ['val', 'id', 'text', 'hide_label'],
  data () {
    return {
      value: this.val
    }
  },
  methods: {
    emitToParent: function () {
      this.$emit('passToParent', this.id, this.value)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/templates/InputTextarea/InputTextarea.vue